import { FC } from 'react'
import { Row, Col, Text, Collapse, CollapseItem, Content, Icon, Image } from '@/client/components'
import * as S from './styles'
import { ApplicationsProps } from '../types'

export const Applications: FC<ApplicationsProps> = ({ application, helper }) => (
  <Row>
    <Col xs={12} lg={7} xl={8}>
      <Text as='h3' family='heading' size='xlg' weight='bold' margin='0 0 2.5rem'>
        {application?.application_title}
      </Text>

      {application?.infos && (
        <Collapse kind='modern'>
          {application?.infos.map(({ info_title, info_content }) => (
            <CollapseItem key={info_title} title={info_title}>
              <Content content={info_content} />
            </CollapseItem>
          ))}
        </Collapse>
      )}
    </Col>
    <Col xs={12} lg={4} lgOffset={1} xl={3} xlOffset={1}>
      <S.Contact>
        <Text as='h3' family='heading' size='xlg' weight='bold' margin='0 0 2.5rem'>
          {helper?.helper_title}
        </Text>

        <S.ContactCard>
          <S.CardImage>
            <Image
              src={helper?.helper_img?.url}
              alt={helper?.helper_img?.alt}
              width={helper?.helper_img?.width}
              height={helper?.helper_img?.height}
              style={{ display: 'block', width: '100%', height: 'auto' }}
            />
          </S.CardImage>
          <S.ContactCardInfos>
            <Text family='heading' size='lg' weight='bold' margin='0 0 0.5rem'>
              {helper?.helper_name}
            </Text>
            <Text color='weak' size='sm'>
              {helper?.helper_position}
            </Text>
            <Text weight='medium' margin='0 0 .25rem'>
              <Icon name='phone' color='#008FBE' />
              <span dangerouslySetInnerHTML={{ __html: helper?.helper_phone }} />
            </Text>
            <Text weight='medium'>
              <Icon name='email' color='#008FBE' />
              <span dangerouslySetInnerHTML={{ __html: helper?.helper_email }} />
            </Text>
          </S.ContactCardInfos>
        </S.ContactCard>
      </S.Contact>
    </Col>
  </Row>
)
